
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/d/[shareId]",
      function () {
        return require("private-next-pages/share/d/[shareId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/d/[shareId]"])
      });
    }
  